import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductSwitchLockPeriods = createAction('[StaticData] Load SwitchLockPeriods');

export const loadProductSwitchLockPeriodsSuccess = createAction(
  '[StaticData] Load SwitchLockPeriods Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductSwitchLockPeriodsFailure = createAction('[StaticData] Load SwitchLockPeriods Failure', props<{ error: any }>());
